// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-area-multi';

export const Component = () => (
  <>
    <g fill='currentColor'>
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M3.672 6.84.576 8.424v4.536L5.4 9.936zM13.32 5.4c-.576.504-1.296.648-2.016.504l-3.168-.72c-.504-.072-1.08 0-1.512.216l-.36.144 2.16 3.96H10.8c.36 0 .648-.072.936-.216l5.76-2.592v-5.04z'
      />
      <path d='m.576 17.424 4.896-3.888c.432-.36 1.08-.576 1.656-.504l3.744.432c.288 0 .576 0 .864-.072l5.76-1.584v5.616H.576V.576z' />
    </g>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m.576 17.424 4.896-3.888c.432-.36 1.08-.576 1.656-.504l3.744.432c.288 0 .576 0 .864-.072l5.76-1.584v5.616zm0 0V.576'
    />
  </>
);

export const viewBox = '0 0 18 18';
